<template>
  <div class="value_color box"
       :style="[filter_item.color ? {'background-color': filter_item.color} : {'background-image': 'url(\'' + filter_item.image + '\')'}]"
        :title="filter_item.value"
        @click="$emit('click')"
  >
    <div v-if="filter_item.selected" class="selected"></div>
  </div>
</template>

<script>
export default {
  name: "value_color",
  props: ['filter_item'],
}
</script>

<style scoped>
.box {
  width: 35px;
  height: 35px;
  border-radius: 2px;
  border: 1px solid #efeff1;
  margin: 3px;
}

.selected {
  opacity: 0.2;
  min-height: 100%;
  min-width: 100%;
  border-radius: 2px;
  background-color: #000000;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M7.45,15.67,3.39,11.61a.75.75,0,1,1,1.06-1.06l3,2.95,8.12-8.92a.75.75,0,1,1,1.11,1Z'/%3E%3C/svg%3E");
}

</style>


<!--{-->
<!--"color": "#FFFF00",-->
<!--"selected": false,-->
<!--"value": "Gelb",-->
<!--"weight": 0.1135,-->
<!--"frequency": null-->
<!--}-->
